import {
  HttpClient,
  HttpParams,
  HttpErrorResponse,
  HttpHeaders,
} from "@angular/common/http";
import { forwardRef, Inject, Injectable } from "@angular/core";
import { Platform } from "ionic-angular";

import { Observable } from "rxjs/Observable";
import { catchError, map, tap, timeout } from "rxjs/operators";

import {
  LoginResponse,
  JSONResponse,
  AppointmentQuery,
  Appointment,
  errorLog,
  cobertura,
  DatosSesion,
  diagnostico,
  FirmaMedicoResponse,
} from "../../mediware-interfaces";
import {
  MedicalHistory,
  Client,
  SearchPatientResponse,
  UserCredentials,
  Patient,
  itemsSetup, itemSetup,
} from "../../mediware-interfaces";
import { SessionProvider } from "../session/session";
import { WebHttpUrlEncodingCodec } from "../../helpers";
import {
  MSG_ACTUALIZAR_WEB,
  MSG_ACTUALIZAR_APP,
  CLIENTS_PAGE,
} from "../../constants";
import moment from "moment";
import { SpeechRecognition } from "@ionic-native/speech-recognition/ngx";
import { findPhoneNumbersInText } from "libphonenumber-js/max";
import { of } from "rxjs/observable/of";

@Injectable()
export class MediwareHubService {
  recognition: any;

  private API_URL = "";
  private API_URL_BASE = "https://mediware.com.ar/MediwareHub"; //es el hosting de creadores de sitios
  private API_URL_SECUNDARIA = "";
  private API_URL_TERCIARIA = ""; //es el servidor de patricio
  private API_URL_CUARTA = "";
  private API_URL_TEST = "";
  private API_URL_DEV = "https://ciccomediware.ddns.net/MediwareHub";
  private API_URL_ICTUM = "https://ciccomediware.ddns.net/MediwareHub"; //para ictum
  private API_URL_CASS = "https://mediware.casstandil.com.ar/MediwareHub"; //servidor de cass
  private API_ORIGEN = "base"; //dev|test|base|secundaria|terciaria|cuarta|ictum|cass
  private PLATAFORMA = "web"; //web|app

  private API_ENDPOINTS = {
    login: "login.php",
    connectToClient: "conectarA.php",
    connectToClientV2: "login.php",
    getAppointmentsV2: "login.php?accion=getJSONTurnos",
    getMedicalHistoryV2: "login.php?accion=getJSONHCPaciente",
    searchPatientV2: "login.php?accion=getJSONDatosPaciente",
    addMedicalHistoryEntryV2: "login.php?accion=agregarConsulta",
    uploadNewFileV2: "login.php?accion=adjuntarAPaciente",
    deleteFileV2: "login.php?accion=eliminarAdjunto",
    bookAppointmentV2: "login.php?accion=reservarTurno",
    grabarTraceV2: "login.php?accion=grabarTrace",
    getHCSegunFuenteV2: "login.php?accion=getHCSegunFuente",
    logError: "logError.php",
    version: "version.php",
    grabarDatosPacienteV2: "login.php?accion=editarDatosPaciente",
    nuevaDensitometriaV2: "login.php?accion=nuevaDensitometria",
    ultimoValorDensitometriaV2: "login.php?accion=ultimoValorDensitometria",
    grabarNotasInteres: "login.php?accion=grabarNotasPaciente",
    getPractica: "login.php?accion=detallesPractica",
    grabarPractica: "login.php?accion=grabarPractica",
    grabarCoberturasPaciente: "login.php?accion=actualizarCoberturasPaciente",
    borrarPractica: "login.php?accion=borrarPractica",
    error: "MediwareHub.php?accion=error",
    errorYdata: "MediwareHub.php?accion=errorYdata",
    errorString: "MediwareHub.php?accion=errorString",
    timeout: "MediwareHub.php",
    cancelarTurno: "login.php?accion=cancelarTurno",
    estadisticasPracticas: "login.php?accion=estadisticasPracticas",
    grabarAntecedentes: "login.php?accion=grabarAntecedentes",
    getMedicionesAntropometria: "login.php?accion=getMedicionesAntropometria",
    grabarMedicionAntropometria:
      "login.php?accion=grabarMedicionesAntropometrias",
    borrarMedicionAntropometria:
      "login.php?accion=borrarMedicionesAntropometrias",
    traceRecetasElectronicas: "login.php?accion=traceRecetasElectronicas",
    datosMedicoRecetasElectronicas:
      "login.php?token=NTI1O0FHUkVHQSBVU1VBUklPO05VRTIwMjM7YWRtaW5odWI7MT&accion=recetaElectronicaInfoMedicos",
    grabarCoberturaGeneral: "login.php?accion=actualizarCoberturaGeneral",
    getDatosCoberturasCompletas:
      "login.php?accion=getCoberturas&soloCoberturas=false&datosCompletos=true",
    borrarCobertura: "login.php?accion=borrarCobertura",
    cambiarClave: "login.php?accion=cambiarClave",
    getDiagnosticos: "login.php?accion=getDiagnosticos",
    grabarDiagnostico: "login.php?accion=grabarDiagnostico",
    borrarDiagnostico: "login.php?accion=borrarDiagnostico",
    grabarNomenclaturaDiagnostico: "login.php?accion=grabarNomenclaDiagnostico",
    borrarNomenclaturaDiagnostico: "login.php?accion=borrarNomenclaDiagnostico",
    getHCMultipleFuentes: "login.php?accion=getHCMultipleFuentes",
    getFirmas: "login.php?accion=getFirmaMedico&matricula=",
    getCoberturasRecetario: "login.php?accion=getCoberturasRecetario",
    getFreeAppointments: "login.php?accion=getTurnosLibres",
    llamarPaciente: "login.php?accion=agregarTurnoEnLlamador",
    getItemsSetup: "login.php?accion=getItemsSetup",
    anularTurnos: "login.php?accion=anularTurnos",
    habilitarTurnos: "login.php?accion=habilitarTurnos",
    buscarPacientesSegunHC: "login.php?accion=buscarPacientesSegunHC",
  };
  private timeout = 30000;
  private timeoutGrabarPractica = 10000;
  private timeoutFileUpload = 30000 * 3; //asi estaba en el valor anterior
  private timeoutSearchPatientV2 = 60000; //asi estaba en el valor anterior

  private URL_getRecetarioLink =
    "https://external-api.recetario.com.ar/quick-links";

  constructor(
    public http: HttpClient,
    public session: SessionProvider,
    public platform: Platform,
    private speech: SpeechRecognition,
  ) {
    this.setAPIURL(this.API_ORIGEN); //default
  }

  getAPIURL(): string {
    return this.API_URL;
  }
  setAPIURL(origen: string) {
    //se tiene que hacer setAPIURL cada vez que se cambia de cliente
    //console.log('setAPIURL origen ' + origen);
    if (!origen) {
      origen = this.API_ORIGEN;
    } //default
    switch (origen) {
      case "base":
        this.API_URL = this.API_URL_BASE;
        break;
      case "secundaria":
        this.API_URL = this.API_URL_SECUNDARIA;
        break;
      case "terciaria":
        this.API_URL = this.API_URL_TERCIARIA;
        break;
      case "cuarta":
        this.API_URL = this.API_URL_CUARTA;
        break;
      case "dev":
        this.API_URL = this.API_URL_DEV;
        break;
      case "test":
        this.API_URL = this.API_URL_TEST;
        break;
      case "ictum":
        this.API_URL = this.API_URL_ICTUM;
        break;
      case "cass":
        this.API_URL = this.API_URL_CASS;
        break;
      default:
        this.API_URL = origen; //no es ninguna de las nomencladas, usamos lo que el cliente paso
        break;
    }
    //console.log('setAPIURL ' + this.API_URL);
  }

  /**
   * Inicia sesión con las credenciales especificadas
   * @param credentials - credenciales del usuario
   */
  login(credentials: UserCredentials): Observable<LoginResponse> {
    let params = new HttpParams()
      .set("idUsuario", credentials.enrollmentId)
      .set("pass", credentials.password);
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = {
      headers,
      params,
    };
    const url = `${this.API_URL}/${this.API_ENDPOINTS.login}`;

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((resp) => {
        console.log(`logged in with user id=${credentials.enrollmentId}`);
        this.session.setSession(resp);
        let cliente = null;
        if (resp && resp.conexion && resp.conexion.data) {
          cliente = resp.conexion.data.cliente;
        }
        //nos guardamos los datos de login
        this.session.setTokenActual(
          credentials.enrollmentId,
          credentials.password,
          "medico",
          cliente,
          // resp["conexio"]["data"]["cliente"],
          "falta: convertir a token-based session",
        );

        let sessionUser = this.session.getUser();
        console.log(
          `usuario=${sessionUser.nombreCompleto} ${sessionUser.tipomatric} ${sessionUser.matricula} - codigo=${sessionUser.codigo}`,
        );
        let sessionMedicoActual = this.session.getMedicoActual();
        if (sessionMedicoActual) {
          console.log(
            `medicoActual=${
              sessionMedicoActual.nombreCompleto ||
              sessionMedicoActual["nombre"]
            } ${
              sessionMedicoActual.tipomatric ||
              sessionMedicoActual["TIPOMATRIC"]
            } ${
              sessionMedicoActual.matricula || sessionMedicoActual["MATRICULA"]
            } - codigo=${sessionMedicoActual.codigo}`,
          );
        }
      }),
      catchError(this.handleAndThrow(`login`, { enviado: params, url: url })),
    );
  }

  /**
   * Conecta a la fuente de datos especificada
   * @param dataSource - nombre de la conexión de la fuente de datos
   */
  connectToClient(dataSource: string): Observable<Client> {
    //API endpoionts V2
    let userType: string = this.session.getTipoUsuarioActual();
    let userActual: string = this.session.getUsuarioActual();
    let userPass: string = this.session.getPassActual();
    let params = new HttpParams()
      .set("conectarA", dataSource)
      .set("idUsuario", userActual)
      .set("pass", userPass)
      .set("tipoLogin", userType);
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url = `${this.API_URL}/${this.API_ENDPOINTS.connectToClientV2}`;
    const options = {
      headers,
      params,
    };
    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((client) => {
        console.log(`connected to client=${dataSource}`);
        let nuevoCliente = null;
        if (client["conexion"]) {
          //si adentro del objeto que nos devolvieron hay un indice conexion, rebuscamos dentro hasta ['conexion']['data']
          //esto es porque estamos usando login.php?conectarA en vez de usar el conectarA.php por el cors
          nuevoCliente = client["conexion"]["data"];
        } else {
          nuevoCliente = client;
        }
        this.session.setActiveClient(nuevoCliente);
        //2022-05-10 actualizamos la publicidad
        if (client["publicidad"]) {
          this.session.setAds(client["publicidad"]);
        }
        //2021-09-02 cargamos los datos del usuario actual, al cambiar de cliente no se recargaba y se estaba usando en algunas funciones y entonces devolvia datos desactualizados
        let nuevoUsuario = null;
        if (client["usuario"]) {
          //si usamos login.php?conectarA viene dentro del item usuario
          nuevoUsuario = client["usuario"];
        } else {
          // si usamos conectarA.php directamente viene dentro del usuarioEnCliente, OJO que hay algunas diferencias entre los dos
          nuevoUsuario = client["usuarioEnCliente"];
        }
        this.session.setUser(nuevoUsuario);
        let sessionUser = this.session.getUser();
        console.log(
          `usuario=${sessionUser.nombreCompleto} ${sessionUser.tipomatric} ${sessionUser.matricula} - codigo=${sessionUser.codigo}`,
        );
        this.session.setMedicoActualByMatricula(sessionUser.matricula); //intentamos poner el usuario actual como medico actual, sino existe esa matricula como medico no setea nada y el .getMedicoActual() de abajo devuelve el primero
        let sessionMedicoActual = this.session.getMedicoActual();
        if (!sessionMedicoActual) {
          console.log("No hay médico actual en sesión");
        } else {
          console.log(
            `medicoActual=${
              sessionMedicoActual.nombreCompleto ||
              sessionMedicoActual["nombre"]
            } ` +
              `${
                sessionMedicoActual.tipomatric ||
                sessionMedicoActual["TIPOMATRIC"]
              } ` +
              `${
                sessionMedicoActual.matricula ||
                sessionMedicoActual["MATRICULA"]
              } ` +
              `- codigo=${
                sessionMedicoActual.codigo || sessionMedicoActual["codigo"]
              }`,
          );
        }

        this.session.setTokenActual(
          userActual,
          userPass,
          userType,
          dataSource,
          "falta: convertir a token-based session",
        ); //esto recrea el token para el cliente conectado actual
      }),
      catchError(
        this.handleAndThrow(`conectar a fuente`, { enviado: params, url: url }),
      ),
    );
  }

  /**
   * Obtiene los turnos en el rango de fechas especificados.
   * @param userId - ID del medico devuelto en el login
   * @param from - fecha desde
   * @param to - fecha hasta
   */

  getAppointments(from: Date, to: Date): Observable<AppointmentQuery> {
    //enviar segun quien sea el medico actual para cambiar entre medicos
    let codigoMedicoActual = this.session.getMedicoActualCode();
    console.log("Código médico actual:", codigoMedicoActual);
    if (codigoMedicoActual) {
      //API ENDPOINT V2
      let params = new HttpParams()
        .set(
          "codigoMedico",
          codigoMedicoActual.toString() != "-1"
            ? codigoMedicoActual.toString()
            : "",
        )
        .set("fechaDesde", this._formatDate(from))
        .set("fechaHasta", this._formatDate(to))
        .set("nombreMedico", "") // vacio, no hace falta setearlo
        .set("momentoDelDia", ""); // vacio, no hace falta setearlo
      const headers = new HttpHeaders().set("Content-Type", "text/plain");
      const url =
        `${this.API_URL}/${this.API_ENDPOINTS.getAppointmentsV2}` +
        this.session.getTokenActual();

      const options = {
        headers,
        params,
      };

      let result = this.http.get<JSONResponse>(url, options);

      return result.pipe(
        timeout(this.timeout),
        map((resp) => resp.data),
        tap((ap) => console.log(`get appointments ${params}`)),
        catchError(
          this.handleAndThrow(`obtener turnos`, { enviado: params, url: url }),
        ),
      );
    }
    return of(null as any);
  }

  getFreeApointments(from: Date, to: Date): Observable<any> {
    // 1. Obtenemos la matrícula
    let matricula = this.session.getMedicoActualMatricula();

    // Validamos que exista y no sea -1
    if (matricula && matricula.toString() !== "-1") {
      // 2. Configuramos los parámetros (CORREGIDO: usar 'matricula')
      let params = new HttpParams()
        .set("matricula", parseInt(matricula.toString()).toString())
        .set("fechaDesde", this._formatDate(from))
        .set("fechaHasta", this._formatDate(to));

      // Si tu token se debe enviar por URL, agrégalo aquí de forma segura
      // params = params.set("token", this.session.getTokenString());

      const headers = new HttpHeaders().set("Content-Type", "text/plain");

      // 3. Construcción de la URL
      // Asumimos que getFreeAppointments es: "MediwareHub.php?accion=getTurnosLibres"
      // Angular se encargará de unir los params con '&' automáticamente.
      let url =
        `${this.API_URL}/${this.API_ENDPOINTS.getFreeAppointments}` +
        this.session.getTokenActual();

      // Si el token es OBLIGATORIO pegarlo al string (legacy), asegúrate que empiece con '&'
      // url += this.session.getTokenActual();

      const options = {
        headers,
        params,
      };

      return this.http.get<JSONResponse>(url, options).pipe(
        timeout(this.timeout),
        map((resp) => {
          // IMPORTANTE: La API devuelve un Objeto { "2025...": {} }, no un Array.
          // Si tu app espera un array, aquí deberías transformarlo.
          return resp.data;
        }),
        tap(() => console.log(`Turnos pedidos para matrícula: ${matricula}`)),
        catchError(
          this.handleAndThrow(`obtener turnos libres`, { matricula, from, to }),
        ),
      );
    }

    return of(null);
  }

  getFirma(matricula: string): Observable<FirmaMedicoResponse> {
    if (!matricula) {
      throw new Error("La matrícula del médico es obligatoria");
    }

    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.getFirmas}${matricula}` +
      this.session.getTokenActual();

    return this.http.get<FirmaMedicoResponse>(url);
  }

  /**
   * Obtiene la historia clinica del paciente.
   * @param userId - ID del medico devuelto en el login
   */
  getMedicalHistory(patientId: number): Observable<MedicalHistory> {
    //API ENDPOINT V2
    let params = new HttpParams().set("idPaciente", patientId.toString());
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.getMedicalHistoryV2}` +
      this.session.getTokenActual();
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((ap) => console.log(`get medical history for id=${patientId}`)),
      catchError(
        this.handleAndThrow(`obtener HC paciente`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }

  /**
   * Busca un paciente por DNI, nombre o ID de paciente.
   * La búsqueda se realiza teniendo un cuenta un solo campo. DNI tiene
   * prioridad sobre nombre de paciente, y este sobre ID de paciente.
   * @param patientDNI - DNI del paciente, puede ser otro tipo de documento como LE u otro.
   * @param patientName - nombre del paciente
   * @param patientId - ID del paciente
   */
  searchPatient(
    patientDNI?: string,
    patientName?: string,
    patientId?: string,
    desde?: string,
  ): Observable<SearchPatientResponse> {
    //API ENDPOINT V2
    let params = new HttpParams();
    if (patientId && patientId != "-1") {
      params = params.set("idPaciente", patientId);
    } else if (
      patientDNI &&
      patientDNI != "" &&
      patientDNI != "0" &&
      patientDNI != "-1" &&
      !isNaN(patientDNI as any)
    ) {
      params = params.set("dniPaciente", patientDNI);
    } else if (patientName) {
      params = params.set("nombrePaciente", patientName);
    }

    if (desde) {
      params = params.set("desde", desde);
    }

    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.searchPatientV2}` +
      this.session.getTokenActual();
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeoutSearchPatientV2),
      map((resp) => resp.data),
      tap((ap) => console.log(`search patient ${params}`)),
      catchError(
        this.handleAndThrow(`buscar paciente`, { enviado: params, url: url }),
      ),
    );
  }

  /**
   * Agrega una práctica de código 42.01.01 al paciente indicado, devuelve el id
   * de la práctica añadida
   * @param patient - paciente al que agregar la consulta
   * @param addedDate - fecha de la consulta
   * @param notes - texto que escribio el médico
   * @param appointment - turno asociado a la consulta
   *
   * Requiere: el paciente debe tener al menos una cobertura registrada
   ************ DEPRECADO ahora agregar una consulta usa grabarPractica
   */
  addMedicalHistoryEntry(
    patient: Patient,
    addedDate: Date,
    notes: string,
    codAut: string,
    appointment?: Appointment,
  ): Observable<number> {
    //API ENDPOINT V2
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("idMedico", this.session.getUserCode().toString())
      .set("idPaciente", patient.numero.toString())
      .set("idCobertura", patient.relpacob[0].codigoCobertura.toString())
      .set("afiliado", patient.relpacob[0].afiliado)
      .set("voluntario", "N") // N por defecto hasta que se actualize el backend
      .set("fecha", this._formatDate(addedDate))
      .set("texto", notes)
      .set("codAut", codAut)
      .set("idTurnoAsociado", appointment ? appointment.id.toString() : "-1");
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.addMedicalHistoryEntryV2}` +
      this.session.getTokenActual();

    //usando post
    const options = {
      headers: headers,
    };
    const postData = { params };
    let result = this.http.post<JSONResponse>(url, postData, options);
    return result.pipe(
      timeout(this.timeoutGrabarPractica),
      map((resp) => resp.data.idPractica.idPractica),
      tap((id) => console.log(`posted MH entry, new entry id=${id}`)),
      catchError(
        this.handleAndThrow(`grabar consulta (deprecado)`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }

  /**
   * Sube un archivo al servidor y devuelve el path del archivo junto con el nuevo nombre del archivo
   * y un mensaje de exito o error.
   * @param file - el contenedor del archivo y su nombre
   * @param description - la descripcion que acompaña al archivo
   * @param idPaciente - el id del paciente
   * @param dni - dni del paciente
   */
  uploadFile(
    file,
    description: string,
    idPaciente: number,
    dni: string,
  ): Observable<JSONResponse> {
    //API ENDPOINT V2
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("idPaciente", idPaciente.toString())
      .set("dniPaciente", dni)
      .set("descripcion", description);
    let formData = new FormData();
    formData.append("adjunto[]", file.file, file.name);

    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.uploadNewFileV2}` +
      this.session.getTokenActual();
    const options = {
      headers,
      params,
    };
    //falta: revisar esto y ver si esta pasando bien los items y que va en formData y que en options
    let result = this.http.post<JSONResponse>(url, formData, options);
    return result.pipe(
      timeout(this.timeoutFileUpload),
      map((resp) => resp.data),
      tap((ap) => console.log(`uploading file ${file.name}`)),
      catchError(
        this.handleAndThrow(`subir archivo `, { enviado: params, url: url }),
      ),
    );
  }

  /**
   * Envia solicitud para borrar archivo en la base de datos
   * @param id id del archivo a borrar
   */
  deleteFile(id: number, idPaciente: number): Observable<JSONResponse> {
    //API ENDPOINT V2
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("idAdjunto", id.toString())
      .set("idPaciente", idPaciente.toString());
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.deleteFileV2}` +
      this.session.getTokenActual();
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((data) => console.log(`deleting file ${id}`)),
      catchError(
        this.handleAndThrow(`borrar archivo`, { enviado: params, url: url }),
      ),
    );
  }

  /**
   * Reserva un turno
   * @param enrollmentId - matricula del medico
   * @param appointment - turno con dia (dd-mm-yyyy) y hora (HH:mm) seteados
   * @param patient - paciente con al menos nombrePaciente y documentoPaciente seteados
   *
   * Opcionalmente el paciente puede tener seteado contacto y al menos una
   * cobertura (relpacob).
   */
  bookAppointment(
    enrollmentId: number,
    appointment: Appointment,
    patient: Patient,
  ): Observable<JSONResponse> {
    //API ENDPOINT V2
    let temp = null;
    let afiliado = "";
    let cobertura = "";
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("matriculaMedico", enrollmentId.toString())
      .set("fecha", appointment.dia.split("-").reverse().join("-"))
      .set("hora", appointment.hora)
      .set("nombrePaciente", patient.nombre)
      .set("documentoPaciente", patient.nrodoc)
      .set("coment", appointment.coment);
    if (patient.telefono) {
      params = params.set("contacto", patient.telefono);
    }
    if (appointment.id) {
      params = params.set("idTurno", appointment.id.toString());
    }
    if (appointment.codigoCobertura) {
      //params = params.set('codigoCobertura', appointment.codigoCobertura.toString()); //no funciona actualmente en el back
      temp = patient.relpacob.find(
        (x) => x.codigoCobertura == appointment.codigoCobertura,
      );
      if (temp) {
        afiliado = temp.afiliado;
        cobertura = temp.onombre;
        params = params.set("nroAfiliado", afiliado);
        params = params.set("cobertura", cobertura);
      }
    }
    if (patient.numero) {
      params = params.set("idPaciente", patient.numero.toString());
    }
    if (appointment.codconsult !== "") {
      params = params.set("nombreConsultorio", appointment.codconsult); //reservarTurno acepta tanto un codigo como un nombre de consultorio
    }

    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.bookAppointmentV2}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((data) => console.log(`booking appointment for ${patient.nombre}`)),
      catchError(
        this.handleAndThrow(`grabar turno`, { enviado: params, url: url }),
      ),
    );
  }

  /**
   * Devuelve un string con la descripción del error.
   * @param err - error
   * @param operation - nombre de la operación que falló
   */
  private prettifyError(err: any, operation = "operation"): string {
    let errDetail: string = "";

    /*
      if (err instanceof HttpErrorResponse && err.error.error)
        errDetail = `with code ${err.error.error.code}: ${err.error.error.message}`;
      else
        errDetail = `${err.message}`;
      */
    if (err instanceof HttpErrorResponse && err.error) {
      if (err.error.error) {
        errDetail = `with code ${err.error.error.code}: ${err.error.error.message}`;
      } else {
        errDetail = `with code ${err.error.code}: ${err.error.message}`;
      }
    } else {
      errDetail = `${err.message}`; //que devuelva algo
    }
    return `${operation} failed ${errDetail}`;
  }

  /**
   * Devuelve el mensaje legible de un error que lanzo handleAndThrow (llega crudo, sin errMsg).
   * @param err - error recibido en el subscribe
   */
  mensajeError(err: any): string {
    if (!err) return "";
    if (err.error && err.error.error && err.error.error.message) {
      return err.error.error.message;
    }
    if (err.error && err.error.message) {
      return err.error.message;
    }
    return err.message || "";
  }

  /**
   * Procesa la operación HTTP que falló y lanza un error.
   * No deja que el flujo de la aplicación continúe.
   * @param operation - nombre de la operación que falló
   */
  private handleAndThrow(operation?: string, context?: any) {
    return (err: any): never => {
      let errMsg = this.prettifyError(err, operation);
      console.error(err);
      console.log(errMsg);

      const fechaError = new Date();
      let body = {
        fecha: fechaError,
        name: err.name,
        message: err.message,
        operation: operation,
      };
      if (err.error) {
        if (err.error.text) {
          body["text"] = err.error.text;
        }
        if (err.error.error) {
          body["error"] = err.error.error;
        }
      }
      if (err.statusText) {
        body["statusText"] = err.statusText;
      }
      if (context) {
        body["context"] = context;
      }
      //if (body['statusText'] == 'Unknown Error' || body.message.indexOf('Unknown Error') > -1) {
      ////vino un mensaje que no nos dice nada, guardar todo el error
      body["errorCompleto"] = err;
      //}
      let data: errorLog = { fecha: fechaError, body: body };
      console.log("agregandoLog");
      this.session.agregarLog(data);

      if (!this.getInDevelopment()) {
        //en DEV, no grabamos el error en el servidor
        const url = `${this.API_URL}/${this.API_ENDPOINTS.logError}`;
        const headers = new HttpHeaders().set("Content-Type", "text/plain");
        const options = {
          headers,
        };
        this.http
          .post(url, body, options)
          .pipe(
            timeout(this.timeout),
            tap((data) => console.log("sending report to server")),
          )
          .subscribe();
      }

      throw err;
    };
  }

  /**
   * Devuelve un string con la fecha formateada como `YYYY-MM-DD`.
   * @param date - fecha a formatear
   */
  _formatDate(date: Date): string {
    // añade un 0 adelante cuando el numero es menor a 10
    function pad(n: number) {
      return n < 10 ? "0" + n : n;
    }

    return (
      date.getFullYear() +
      "-" +
      pad(date.getMonth() + 1) +
      "-" +
      pad(date.getDate())
    );
  }

  async getForaneousMedicalHistory(
    nrodoc: number,
    fuente: string,
  ): Promise<any> {
    //Observable<MedicalHistory> {
    //hace una llamada a MediwareHub.getHCSegunFuente
    //  devuelve resultados por [data] (un array de resultados)
    //      si no encontro el paciente devuelve [data] = ''
    //  los errores de "Fuente no habilitada", "Timeout" y demas errores vuelven por [error]
    //API ENDPOINT V2
    let params = new HttpParams()
      .set("nrodocPaciente", nrodoc.toString())
      .set("idFuente", fuente);
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.getHCSegunFuenteV2}` +
      this.session.getTokenActual();
    const options = {
      headers,
      params,
    };
    //por que es distinto este?
    let data = await this.http
      .get<JSONResponse>(url, options)
      .toPromise()
      .catch(function (e) {
        console.log(e);

        const fechaError = new Date();
        let body = {
          fecha: fechaError,
          name: e.name,
          message: e.statusText,
          operation: "getHCSegunFuente",
          error: e,
          context: { enviado: params, url: url },
        };
        let data: errorLog = { fecha: fechaError, body: body };
        console.log("agregandoLog");
        this.session.agregarLog(data);

        let errorResp = [];
        errorResp["error"] = [];

        errorResp["error"]["code"] = e.status;
        errorResp["error"]["message"] = e.statusText;

        return errorResp;
      });

    return data;
  }

  grabarTrace(
    pantalla: string,
    accionTrace: string,
    contenido: string,
  ): Observable<string> {
    //API ENDPOINT V2
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("pantalla", pantalla)
      .set("accionTrace", accionTrace)
      .set("contenido", contenido);
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.grabarTraceV2}` +
      this.session.getTokenActual();
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data.message),
      tap((message) => console.log(`grabarTrace: ${message}`)),
      catchError(
        this.handleAndThrow(`grabarTrace`, { enviado: params, url: url }),
      ),
    );
  }

  obtenerVersion(): Observable<string> {
    const url = `${this.API_URL}/${this.API_ENDPOINTS.version}`;
    let result = this.http.get<JSONResponse>(url);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((message) => console.log(`obtenerVersion: ${message["appVersion"]}`)),
      catchError(this.handleAndThrow(`obtenerVersion()`, { url: url })),
    );
  }

  getPlataforma(): string {
    return this.PLATAFORMA;
  }
  getInDevelopment(): boolean {
    return this.API_ORIGEN == "dev";
  }
  getMensajeActualizar(): string {
    if (this.PLATAFORMA == "web") {
      return MSG_ACTUALIZAR_WEB;
    } else {
      return MSG_ACTUALIZAR_APP;
    }
  }

  /**
   * sirve para agregar y editar pacientes
   */
  /**
   * @param patient - datos a grabar, patient.nrodoc es el dni que queda
   * @param nrodocAnterior - dni que tiene grabado en la base (si no viene, se asume que no cambio)
   */
  grabarDatosPaciente(
    patient: Patient,
    nrodocAnterior?: string,
  ): Observable<JSONResponse> {
    //accion=editarDatosPaciente&idPac=6191&nombrePac=PERRI%20ISABELLA&dniPac=52031256&fechaNac=2012-01-05&sexo=F&direccion=bla&localidad=Tandil&telefono=2216243850&grupo=Z

    //las fechas son complicadas, en este momento pueden venir en dos formatos
    //    preguntar si vienen en DD/MM/YYYY
    let fechaISO = "";
    let fechaMoment = moment(patient.fechaNac, "DD/MM/YYYY", true);
    if (!fechaMoment.isValid()) {
      //si no vino, tratar de parsearla como 'YYYY-MM-DD'
      fechaMoment = moment(patient.fechaNac, "YYYY-MM-DD", true);
      if (fechaMoment.isValid()) {
        fechaISO = fechaMoment.format("YYYY-MM-DD");
      } else {
        fechaISO = ""; //si es vacio el backend lo pone en null
      }
    }

    let params = new HttpParams()
      .set("idPac", patient.numero.toString())
      .set("nombrePac", patient.nombre)
      .set("dniPac", nrodocAnterior || patient.nrodoc) //el que tiene grabado
      .set("nuevodniPac", patient.nrodoc) //el que se va a grabar
      .set("fechaNac", fechaISO)
      .set("sexo", patient.sexo)
      .set("grupo", patient.grupo)
      .set("factor", encodeURIComponent(patient.factor))
      .set("peso", patient.peso)
      .set("talla", patient.talla)
      .set("email", patient.email)
      .set("profesion", patient.profesion)
      .set("telefono", patient.telefono)
      .set("direccion", patient.direcc)
      .set("localidad", patient.localidad);
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.grabarDatosPacienteV2}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((data) => console.log(`grabando datos de ${patient.nombre}`)),
      catchError(
        this.handleAndThrow(`grabarDatosPaciente`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }

  /**
   * agrega una densitometria
   * monton de parametros
   *******************DEPRECADO ahora hacer una densitometria usa grabarPractica
   */
  addDensitometriaEntry(
    patient: Patient,
    addedDate: Date,
    metodo: string,
    zonaCol: string,
    grcm2Col: string,
    deltaCol: string,
    zonaCDC: string,
    grcm2CDC: string,
    deltaCDC: string,
    zonaCDT: string,
    grcm2CDT: string,
    deltaCDT: string,
    zonaCIC: string,
    grcm2CIC: string,
    deltaCIC: string,
    zonaCIT: string,
    grcm2CIT: string,
    deltaCIT: string,
    zonaAntBr: string,
    grcm2AntBr: string,
    deltaAntBr: string,
    tscoreCol: string,
    zscoreCol: string,
    tscoreCDC: string,
    zscoreCDC: string,
    tscoreCDT: string,
    zscoreCDT: string,
    tscoreCIC: string,
    zscoreCIC: string,
    tscoreCIT: string,
    zscoreCIT: string,
    tscoreAntBr: string,
    zscoreAntBr: string,
    notes: string,
    appointment?: Appointment,
  ): Observable<number> {
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("idMedico", this.session.getUserCode().toString())
      .set("idPaciente", patient.numero.toString())
      .set("fecha", this._formatDate(addedDate))
      .set("metodo", metodo)
      .set("zonaCol", zonaCol)
      .set("grcm2Col", grcm2Col)
      .set("deltaCol", deltaCol)
      .set("zonaCDC", zonaCDC)
      .set("grcm2CDC", grcm2CDC)
      .set("deltaCDC", deltaCDC)
      .set("zonaCDT", zonaCDT)
      .set("grcm2CDT", grcm2CDT)
      .set("deltaCDT", deltaCDT)
      .set("zonaCIC", zonaCIC)
      .set("grcm2CIC", grcm2CIC)
      .set("deltaCIC", deltaCIC)
      .set("zonaCIT", zonaCIT)
      .set("grcm2CIT", grcm2CIT)
      .set("deltaCIT", deltaCIT)
      .set("zonaAntBr", zonaAntBr)
      .set("grcm2AntBr", grcm2AntBr)
      .set("deltaAntBr", deltaAntBr)
      .set("tscoreCol", tscoreCol)
      .set("zscoreCol", zscoreCol)
      .set("tscoreCDC", tscoreCDC)
      .set("zscoreCDC", zscoreCDC)
      .set("tscoreCDT", tscoreCDT)
      .set("zscoreCDT", zscoreCDT)
      .set("tscoreCIC", tscoreCIC)
      .set("zscoreCIC", zscoreCIC)
      .set("tscoreCIT", tscoreCIT)
      .set("zscoreCIT", zscoreCIT)
      .set("tscoreAntBr", tscoreAntBr)
      .set("zscoreAntBr", zscoreAntBr)
      .set("texto", notes)
      .set("idTurnoAsociado", appointment ? appointment.id.toString() : "-1");
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.nuevaDensitometriaV2}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((id) => console.log(`posted MH densitometria, new id=${id}`)),
      catchError(
        this.handleAndThrow(`nueva Densitometria (deprecado)`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }

  /**
   * Pide los ultimos valores de los items de densitometria para calcular el % de cambio
   */
  ultimoValorDensitometria(patient: Patient): Observable<number> {
    if (patient) {
      let params = new HttpParams({
        encoder: new WebHttpUrlEncodingCodec(),
      }).set("idPaciente", patient.numero.toString());
      const headers = new HttpHeaders().set("Content-Type", "text/plain");
      const url =
        `${this.API_URL}/${this.API_ENDPOINTS.ultimoValorDensitometriaV2}` +
        this.session.getTokenActual(); //API ENDPOINT V2
      const options = {
        headers,
        params,
      };

      let result = this.http.get<JSONResponse>(url, options);

      return result.pipe(
        timeout(this.timeout),
        map((resp) => resp.data["densitometria"]),
        tap((id) => console.log(`getting ultimo valor densitometria`)),
        catchError(
          this.handleAndThrow(`ultimoValorDensitometria`, {
            enviado: params,
            url: url,
          }),
        ),
      );
    } else {
      return null;
    }
  }
  /**
   * sirve para agregar y editar notas de interes
   */
  grabarNotasInteres(
    numero: number,
    notaInteres: string,
  ): Observable<JSONResponse> {
    let params = new HttpParams()
      .set("notasInteres", notaInteres)
      .set("idPaciente", numero.toString());
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.grabarNotasInteres}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((data) => console.log(`grabando datos de id: ${numero}`)),
      catchError(
        this.handleAndThrow(`grabarNotasInteres`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }

  /**
   * agregar y editar la ficha de antecedentes
   *   de momento tratamos los antecedentes como un campo texto grande (2021-10-18)
   */
  grabarAntecedentes(
    numero: number,
    antecedentes: string,
  ): Observable<JSONResponse> {
    let params = new HttpParams()
      .set("antecedentes", antecedentes)
      .set("idPaciente", numero.toString());
    const postData = { params };
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = { headers: headers };
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.grabarAntecedentes}` +
      this.session.getTokenActual(); //API ENDPOINT V2

    let result = this.http.post<JSONResponse>(url, postData, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((data) => console.log(`grabando antecedentes de id: ${numero}`)),
      catchError(
        this.handleAndThrow(`grabarAntecedentes`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }
  /**
   * Pide el detalle de una practica
   */
  detallesPractica(
    idPractica: number,
    codigoPractica: string,
    nombrePractica: string,
  ): Observable<any> {
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("idPractica", idPractica.toString())
      .set("codigoPractica", codigoPractica.toString())
      .set("nombrePractica", nombrePractica.toString());
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.getPractica}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((id) => {
        console.log(`getting densitometria: `);
        //console.log(resp);
      }),
      catchError(
        this.handleAndThrow(`detallesPractica`, { enviado: params, url: url }),
      ),
    );
  }

  /**
   * sirve para agregar y editar practicas
   */
  grabarPractica(data: any) {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.grabarPractica}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    let params = new HttpParams().set("data", data);
    const postData = { params };
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = { headers: headers };
    let result = this.http.post<JSONResponse>(url, postData, options);
    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap(
        (data) => {
          console.log(`grabando datos de practica:`);
          console.log(data);
        },
        catchError(
          this.handleAndThrow(`grabarPractica`, { enviado: params, url: url }),
        ),
      ),
    );
  }

  grabarCoberturas(idPaciente: number, arrRelPacOb: Array<any>) {
    let params = new HttpParams()
      .set("idPaciente", idPaciente.toString())
      .set("arrRelPacOb", JSON.stringify(arrRelPacOb));
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.grabarCoberturasPaciente}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = { headers: headers };
    const postData = { params };

    let result = this.http.post<JSONResponse>(url, postData, options);
    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap(
        (data) => {
          console.log(`grabando datos de coberturas:`);
          console.log(idPaciente);
          console.log(arrRelPacOb);
        },
        catchError(
          this.handleAndThrow(`grabarCoberturas`, {
            enviado: params,
            url: url,
          }),
        ),
      ),
    );
  }
  grabarCoberturaGeneral(cobertura: cobertura): Observable<any> {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.grabarCoberturaGeneral}` +
      this.session.getTokenActual();
    let params = new HttpParams().set("cobertura", JSON.stringify(cobertura));
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const body = { params };
    const options = { headers: headers };

    return this.http.post<JSONResponse>(url, body, options).pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      catchError(
        this.handleAndThrow("grabarCoberturaGeneral", {
          enviado: cobertura,
          url,
        }),
      ),
    );
  }

  getDatosCompletosCoberturas(): Observable<any> {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.getDatosCoberturasCompletas}` +
      this.session.getTokenActual();
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = { headers };

    return this.http.get<JSONResponse>(url, options).pipe(
      timeout(this.timeout),
      tap((data) => console.log("Datos de coberturas recibidos:", data)),
      catchError(this.handleAndThrow("get Cobertura completa ", { url })),
    );
  }

  private coberturasCompletas: cobertura;

  cargarYProcesarCoberturas() {
    this.getDatosCompletosCoberturas().subscribe({
      next: (data) => {
        this.session.setCoberturas(data.data);
        // Llama a una función para procesar los datos
      },
      error: (error) => {
        console.error("Error al cargar los datos:", error);
      },
      complete: () => {
        console.log("Carga de datos completada"); // Opcional: para lógica adicional al completarse
      },
    });
  }
  cargarYprocesarDiagnosticos() {
    this.getDiagnosticos().subscribe({
      next: (data) => {
        console.log("Datos diagnosticos recibidos :", data);
        this.session.setDiagnosticos(data);
        // Llama a una función para procesar los datos
      },
      error: (error) => {
        console.error("Error al cargar los datos de diagnostico:", error);
      },
      complete: () => {
        console.log("Carga de datos  de diagnosticos completada"); // Opcional: para lógica adicional al completarse
      },
    });
  }

  setDatosSesion(data: DatosSesion) {
    this.session.setCoberturas(data.coberturas);
    this.session.setTiposAfiliadoCoberturas(data.tiposAfiliadoCoberturas);
    this.session.setGerenciaCoberturas(data.gerenciaCoberturas);
    this.session.setConsultorios(data.consultorios);

    this.cargarYProcesarCoberturas();
    this.cargarYprocesarDiagnosticos();
    this.cargarYprocesarCoberturasRecetario();
    this.getItemsSetup().subscribe({
      next: (data) => {
        //console.log("items setup recibidos:", data);
        this.session.setItemsSetup(data);
      }
      , error: (error) => {
        console.error("Error getItemsSetup: ", error);
      }
    });
  }

  borrarCobertura(cobertura: any): Observable<any> {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.borrarCobertura}` +
      this.session.getTokenActual();
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const body = { cobertura };
    const options = { headers: headers };
    console.log(body);
    return this.http.post<JSONResponse>(url, body, options).pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      catchError(
        this.handleAndThrow("borrar cobertura", { enviado: body, url }),
      ),
    );
  }

  getDiagnosticos(): Observable<any> {
    const token = this.session.getTokenActual();
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.getDiagnosticos}` +
      this.session.getTokenActual();
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = {
      headers,
    };
    let result = this.http.get<JSONResponse>(url, options);
    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      catchError(
        this.handleAndThrow(`obtener diagnostico paciente`, {
          url: url,
        }),
      ),
    );
  }

  cargarDiagnosticos(): Observable<any> {
    return this.getDiagnosticos().pipe(
      map((data) => this.session.setDiagnosticos(data)),
    );
  }

  borraPractica(idPaciente: number, idPractica: number, idMedico: number) {
    let params = new HttpParams()
      .set("idPaciente", idPaciente.toString())
      .set("idPractica", idPractica.toString())
      .set("idMedico", idMedico.toString());
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.borrarPractica}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = { headers: headers };
    const postData = { params };

    let result = this.http.post<JSONResponse>(url, postData, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap(
        (data) => {
          console.log(`eliminando practica:`);
          console.log(idPractica);
          console.log(idPaciente);
          console.log(idMedico);
        },
        catchError(
          this.handleAndThrow(`borraPractica`, { enviado: params, url: url }),
        ),
      ),
    );
  }

  simularError(tipo: string) {
    let params = new HttpParams();
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = {
      headers,
      params,
    };
    let miTimeout = this.timeout;
    let url = "";
    if (tipo == "error") {
      url = `${this.API_URL}/${this.API_ENDPOINTS.error}`;
    }
    if (tipo == "errorYdata") {
      url = `${this.API_URL}/${this.API_ENDPOINTS.errorYdata}`;
    }
    if (tipo == "errorString") {
      url = `${this.API_URL}/${this.API_ENDPOINTS.errorString}`;
    }
    if (tipo == "timeout") {
      url = `${this.API_URL}/${this.API_ENDPOINTS.timeout}`;
      miTimeout = 1; //para que de el error de timeout instantaneamente
    }

    let result = this.http.get<any>(url, options);

    return result.pipe(
      timeout(miTimeout),
      map((resp) => resp.data),
      tap((client) => {
        console.log("simulando " + tipo);
      }),
      catchError(
        this.handleAndThrow(`simular ` + tipo, { enviado: params, url: url }),
      ),
    );
  }

  cancelarTurno(
    matriculaMedico: number,
    fecha: string,
    hora: string,
    idTurno: number = -1,
    idPaciente: number = -1,
    documentoPaciente: number = -1,
  ) {
    let params = new HttpParams()
      .set("matriculaMedico", matriculaMedico.toString())
      .set("fecha", fecha)
      .set("hora", hora)
      .set("idTurno", idTurno.toString())
      .set("idPaciente", idPaciente.toString())
      .set("documentoPaciente", documentoPaciente.toString());
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.cancelarTurno}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap(
        (data) => {
          console.log(`eliminando turno:`);
        },
        catchError(
          this.handleAndThrow(`cancelarTurno`, { enviado: params, url: url }),
        ),
      ),
    );
  }

  /**
   * Anula (deshabilita) varios turnos de una.
   * @param matricula matrícula del médico
   * @param listaTurnos array con formato "matricula-YYYY-MM-DD HH:mm"
   *        ej: ['31216-2026-08-01 08:00', '31216-2026-08-01 08:30']
   * POST: matricula + turnos[] (array)
   */
  anularTurnos(matricula: number | string, listaTurnos: string[]) {
    return this._postTurnos(
      this.API_ENDPOINTS.anularTurnos,
      matricula,
      listaTurnos,
      "anularTurnos",
    );
  }

  /**
   * Habilita varios turnos de una. Mismo contrato que anularTurnos.
   */
  habilitarTurnos(matricula: number | string, listaTurnos: string[]) {
    return this._postTurnos(
      this.API_ENDPOINTS.habilitarTurnos,
      matricula,
      listaTurnos,
      "habilitarTurnos",
    );
  }

  /**
   * POST con matricula (string) + turnos como array PHP (turnos[]).
   */
  private _postTurnos(
    endpoint: string,
    matricula: number | string,
    listaTurnos: string[],
    nombre: string,
  ) {
    let body = new HttpParams({
      encoder: new WebHttpUrlEncodingCodec(),
    }).set("matricula", matricula.toString());
    // turnos como array PHP: turnos[]=...&turnos[]=...
    listaTurnos.forEach((t) => {
      body = body.append("turnos[]", t);
    });

    const headers = new HttpHeaders().set(
      "Content-Type",
      "application/x-www-form-urlencoded",
    );
    const url =
      `${this.API_URL}/${endpoint}` + this.session.getTokenActual();

    let result = this.http.post<JSONResponse>(url, body.toString(), { headers });

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap(() => console.log(`${nombre}: ${listaTurnos.length} turno(s)`)),
      catchError(
        this.handleAndThrow(nombre, { enviado: body.toString(), url: url }),
      ),
    );
  }

  buscarEstadisticasPracticas(data: any) {
    let params = new HttpParams().set("data", data); //la magia es real

    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.estadisticasPracticas}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = { headers: headers };
    const postData = { params };
    let result = this.http.post<JSONResponse>(url, postData, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap(
        (data) => {
          console.log(`buscando estadisticas practicas:`);
        },
        catchError(
          this.handleAndThrow(`buscarEstadisticasPracticas`, {
            enviado: params,
            url: url,
          }),
        ),
      ),
    );
  }

  // busca pacientes cuya historia clinica contiene los terminos dados
  // data: { terminos: string[], operador?: 'AND'|'OR' (default OR), matricula?, especialidad?, desde? }
  // se manda "data" directo como body (JSON real), no envuelto en HttpParams
  buscarPacientesSegunHC(data: any) {
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.buscarPacientesSegunHC}` +
      this.session.getTokenActual();
    const options = { headers: headers };
    let result = this.http.post<JSONResponse>(url, data, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap(
        (resp) => {
          console.log(`buscarPacientesSegunHC:`, resp);
        },
        catchError(
          this.handleAndThrow(`buscarPacientesSegunHC`, {
            enviado: data,
            url: url,
          }),
        ),
      ),
    );
  }

  enviarRecodatorioTurnoWsp(recordatorio: any) {
    let wspUrl = "https://api.whatsapp.com/send?";
    let wspPhone = "phone=" + recordatorio["numeroWsp"];
    let wspText =
      "&text=Recordatorio de turno para " +
      recordatorio["nombreMedico"] +
      " del dia " +
      recordatorio["dia"] +
      " " +
      recordatorio["hora"] +
      "%0A%0APOR FAVOR CONFIRMAR SI ASISTE AL TURNO, MUCHAS GRACIAS"; // %0A es el separador de linea (enter) = encodeURI('\n')

    wspUrl += wspPhone + wspText;

    window.open(wspUrl, "_blank");
  }
  tieneWspValido(turno: Appointment): any {
    if (!turno) {
      return false;
    }
    if (!turno.motivo) {
      return false;
    }
    //console.log(turno.motivo);
    //buscar en el texto un nro de telefono , mirar libphonenumber-js que tiene una funcion para eso, y parsearlo para wsp (formato internacional)
    //  por ej turno.motivo='+54 11 3142 2892 mdb62.d@gmail.com'
    //                      '2493188550'
    let wspValido = findPhoneNumbersInText(turno.motivo, "AR");
    //console.log(wspValido);
    if (
      !wspValido ||
      wspValido.length == 0 ||
      !wspValido[0].number ||
      !wspValido[0].number.number
    ) {
      return false;
    } //no encontro nada que sea un numero

    return wspValido[0].number.number; //devuelve true porque suponemos que wspValido[0].number.number es un numero valido
  }

 calcularIMC(peso: number, talla: number): number {
  if (!peso || !talla) return 0;

  let tallaMts = talla;

  // si es mayor a 3 → probablemente está en cm
  if (talla > 3) {
    tallaMts = talla / 100;
  }

  return Number((peso / Math.pow(tallaMts, 2)).toFixed(2));
}
  imcColor(imcValue: Number, imcValores: string): string {
    if (!imcValue) {
      return "";
    }
    if (!imcValores) {
      return "";
    } //sin referencia

    let arrIMC = imcValores.split(",");
    let numberIMC = Number(imcValue);
    if (numberIMC < Number(arrIMC[0])) {
      //inferior<18.5
      return "semaforo-circulo semaforo-amarillo"; //  amarillo
    } else if (numberIMC < Number(arrIMC[1])) {
      //normal<24.9
      return "semaforo-circulo semaforo-verde"; //  verde
    } else if (numberIMC < Number(arrIMC[2])) {
      //superior<29.9
      return "semaforo-circulo semaforo-amarillo"; //  amarillo
    } else {
      //obesidad>=30
      return "semaforo-circulo semaforo-rojo"; //  rojo
    }
  }
  AntropometriaVarItemClassColor(itemVar: string): string {
    if (itemVar == "UP") {
      return "semaforo-circulo pulgarArriba fas fa-thumbs-up";
    } else if (itemVar == "DN") {
      return "semaforo-circulo pulgarAbajo fas fa-thumbs-down";
    }
    return "semaforo-circulo";
  }
  getMedicionesAntropometria(idPaciente: number) {
    let params = new HttpParams().set("idPaciente", idPaciente.toString());

    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.getMedicionesAntropometria}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = {
      headers,
      params,
    };

    return this.http.get<JSONResponse>(url, options).pipe(
      timeout(this.timeout),
      map((resp) => resp.data.antropometrias),
      tap(() => {
        console.log(`getMedicionesAntropometria`);
      }),
      catchError(
        this.handleAndThrow(`getMedicionesAntropometria`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }

 grabarMedicionAntropometria(data: any, idPaciente: number) {
  const headers = new HttpHeaders().set("Content-Type", "text/plain");
  const url = `${this.API_URL}/${this.API_ENDPOINTS.grabarMedicionAntropometria}` + this.session.getTokenActual();
  const options = { headers };
  const postData = { data, idPaciente };  // ← mejor mandar como body JSON

  return this.http.post<JSONResponse>(url, postData, options).pipe(
    timeout(this.timeout),
    map(resp => resp.data),
    tap(data => {
      console.log(`grabarMedicionAntropometria:`, data);
    }),
    catchError(  // ← acá afuera del tap, encadenado
      this.handleAndThrow(`grabarMedicionAntropometria`, { data, url })
    )
  );
}
  borrarMedicionAntropometria(idAntro: number, idPaciente: number) {
    let params = new HttpParams()
      .set("idAntro", idAntro.toString())
      .set("idPaciente", idPaciente.toString());

    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.borrarMedicionAntropometria}` +
      this.session.getTokenActual(); //API ENDPOINT V2
    const options = { headers: headers };
    const postData = { params };
    let result = this.http.post<JSONResponse>(url, postData, options); //graba tambien en antroultima y en pacesp

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap(
        (data) => {
          console.log(`grabarMedicionAntropometria`);
        },
        catchError(
          this.handleAndThrow(`grabarMedicionAntropometria`, {
            enviado: params,
            url: url,
          }),
        ),
      ),
    );
  }

  getRecetarioLinks(medico, paciente, itemsReceta, referenciaRec) {
    //los links duran 20 min, por ahora no vale la pena guardarlos
    /*
    https://external-api.recetario.com.ar/quick-links
    Authorization	Bearer 2f68dbbf-519d-4f01-9636-e2421b68f379
pedido
    {
        "doctor": {
            "email": "string",
            "name": "string",
            "surname": "string",
            "licenseType": "string",  licenseType: Tipo de licencia: "nacional" o "provincial"
            "licenseNumber": "string",
            "documentNumber": "string",
            "province": "string",
            "title": "string",
            "specialty": "string",
            "healthCenterId": 0,
            "signature": "string"
        },
        "patient": {
            "healthInsurance": "string",
            "insuranceNumber": "string",
            "name": "string",
            "surname": "string",
            "documentNumber": "string",
            "email": "user@example.com",
            "phone": "string",
            "gender": "string", gender: Género del paciente. "m" si es hombre, "f" si es mujer y "o" si no se especifica
            "birthDate": "string"
        },
        "reference": "string" reference: cliente-matricula-nrodocpaciente-fechaYYYY-MM-DD
    }
respuesta    
    {
      "prescriptionsLink": "string",
      "ordersLink": "string"
    }
    
    $_temp['usuarioEnCliente']['permisos'] = $_temp['usuarioEnCliente']['permisos'] . ' ' . $_FLAG_RECETA_ELECTRONICA;
                            $_temp[$_FLAG_RECETA_ELECTRONICA]['idInstitucion'] = 383;
                            $_temp[$_FLAG_RECETA_ELECTRONICA]['token'] = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MjN9.k1Vu8-hNp7uDXA9w5uT3pgpVDymlk6Y0_maUDslN2kk';
   */
    let firmaMedico = itemsReceta["doctor"]["signature"].replace(
      "data:image/png;base64,",
      "",
    ); //2025-06-01 sacamos la cabecera del base64png
    let body = JSON.stringify({
      doctor: {
        email: itemsReceta["doctor"]["email"],
        name: itemsReceta["doctor"]["name"],
        surname: itemsReceta["doctor"]["surname"],
        licenseType: itemsReceta["doctor"]["licenseType"],
        licenseNumber: itemsReceta["doctor"]["licenseNumber"],
        documentNumber: itemsReceta["doctor"]["documentNumber"],
        province: itemsReceta["doctor"]["province"] || "Buenos Aires",
        title: itemsReceta["doctor"]["title"],
        specialty: itemsReceta["doctor"]["specialty"],
        healthCenterId: itemsReceta["idInstitucion"],
        signature: firmaMedico,
        profile: {
          legend: itemsReceta["doctor"]["profile"]["legend"],
          phone: itemsReceta["doctor"]["profile"]["phone"],
          address: itemsReceta["doctor"]["profile"]["address"],
          email: itemsReceta["doctor"]["profile"]["emailprofile"],
        },
      },
      patient: {
        healthInsurance: paciente.relpacob[0].onombre,
        insuranceNumber: paciente.relpacob[0].afiliado,
        name: paciente["selPatientNombre"],
        surname: paciente["selPatientApellido"],
        documentNumber: paciente.nrodoc,
        email: paciente.email,
        phone:
          paciente["wasap"] && paciente["wasap"].length == 10
            ? paciente["wasap"]
            : paciente.telefono,
        gender:
          paciente.sexo == "M"
            ? "m"
            : paciente.sexo == "F"
              ? "f"
              : paciente.sexo,
        birthDate: paciente.fechaNac,
      },
      reference: referenciaRec,
    });
    const headers = {
      Authorization: "Bearer " + this.session.getRecetarioComArBearerAuth(),
      "Content-Type": "application/json",
    };
    //, 'Referrer-Policy': 'strict-origin-when-cross-origin', 'Referer': 'http://localhost:8100'
    const url = `${this.URL_getRecetarioLink}`;
    const options = { headers: headers };
    const postData = { body };

    let result = this.http.post<JSONResponse>(url, body, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp),
      tap(
        (resp) => {
          console.log(`getRecetarioLinks`, resp);
        },
        catchError(
          this.handleAndThrow(`getRecetarioLinks`, { enviado: body, url: url }),
        ),
      ),
    );
  }
  traceRecetasElectronicas(
    pantalla: string,
    accionTrace: string,
    contenido: string,
  ): Observable<string> {
    //API ENDPOINT V2
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("pantalla", pantalla)
      .set("accionTrace", accionTrace)
      .set("contenido", contenido);
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.traceRecetasElectronicas}` +
      this.session.getTokenActual();
    const options = {
      headers,
      params,
    };

    let result = this.http.get<JSONResponse>(url, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data.message),
      tap((message) => console.log(`traceRecetasElectronicas: ${message}`)),
      catchError(
        this.handleAndThrow(`traceRecetasElectronicas`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }
  grabarNomenclaturaDiagnostico(
    nombre: string,
    codigo: string,
    especialidad: string,
    nombreAnterior: string,
    relCodForm?: string,
  ): Observable<any> {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.grabarNomenclaturaDiagnostico}` +
      this.session.getTokenActual();
    const body: any = {
      nombre: nombre,
      codigo: codigo,
      especialidad: especialidad,
      nombreAnterior: nombreAnterior,
    };
    // Solo se incluye RelCodForm cuando fue enviado explícitamente
    // (undefined = no tocar; "" = borrar el valor; cualquier string = setear)
    if (relCodForm !== undefined) {
      body.RelCodForm = relCodForm;
    }
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = { headers: headers };
    let result = this.http.post<JSONResponse>(url, body, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp),
      tap(
        (resp) => {
          console.log(`grabarNomenDiag`, resp);
        },
        catchError(
          this.handleAndThrow(`grabarNomenDiag`, { enviado: body, url: url }),
        ),
      ),
    );
  }

  borrarNomenclaturaDiagnostico(
    nombre: string,
    codigo: string,
    especialidad: string,
  ): Observable<any> {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.borrarNomenclaturaDiagnostico}` +
      this.session.getTokenActual();
    const body = {
      nombre: nombre,
      codigo: codigo,
      especialidad: especialidad,
    };
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = { headers: headers };
    let result = this.http.post<JSONResponse>(url, body, options);

    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp),
      tap(
        (resp) => {
          console.log(`borrarNomenDiag`, resp);
        },
        catchError(
          this.handleAndThrow(`borrarNomenDiag`, { enviado: body, url: url }),
        ),
      ),
    );
  }

  grabarDiagnostico(
    idPaciente: number,
    idMedico: number,
    idCobertura: number,
    codigo_problema: string,
    fecha: string,
    texto?: string,
    detalle?: string,
    idproblema?: number,
  ): Observable<any> {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.grabarDiagnostico}` +
      this.session.getTokenActual();
    const body = {
      idPaciente: idPaciente,
      idMedico: idMedico,
      idCobertura: idCobertura,
      codigo_problema: codigo_problema,
      fecha: fecha,
      texto: texto,
      detalle: detalle,
      idproblema: idproblema,
    };
    return this.http.post<JSONResponse>(url, body);
  }

  borrarDiagnostico(
    idPaciente: number,
    idMedico: number,
    idCobertura: number,
    codigo_problema: string,
    fecha: string,
  ): Observable<any> {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.borrarDiagnostico}` +
      this.session.getTokenActual();
    const body = {
      idPaciente: idPaciente,
      idMedico: idMedico,
      idCobertura: idCobertura,
      codigo_problema: codigo_problema,
      fecha: fecha,
    };
    return this.http.post<JSONResponse>(url, body);
  }

  datosMedicoRecetasElectronicas(cliente: string, matricula: string) {
    //pide los datos de receta electronica del medico para que se actualice en la sesion
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("cliente", cliente)
      .set("medico", matricula);
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    //API ENDPOINT V2
    const url = `${this.API_URL}/${this.API_ENDPOINTS.datosMedicoRecetasElectronicas}`; // este va sin + this.session.getTokenActual() porque es va con un token especial
    const options = {
      headers,
      params,
    };
    let result = this.http.get<JSONResponse>(url, options);
    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp),
      tap((resp) =>
        console.log(`datosMedicoRecetasElectronicas: ${resp}`, resp),
      ),
      catchError(
        this.handleAndThrow(`datosMedicoRecetasElectronicas`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }

  cambiarClave(claveAnt: string, nuevaClave: string): Observable<any> {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.cambiarClave}` +
      this.session.getTokenActual();
    const body = {
      nuevaClave: nuevaClave,
      claveAnt: claveAnt,
    };
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = { headers: headers };

    return this.http.post<JSONResponse>(url, body, options);

    /*
    let params = new HttpParams()
      .set("idAntro", idAntro.toString())
      .set("idPaciente", idPaciente.toString());    
    const options = { headers: headers };
    const postData = { params };
    let result = this.http.post<JSONResponse>(url, postData, options); //graba tambien en antroultima y en pacesp
*/
  }

  getHCMultipleFuentes(nrodocPaciente: string, omitirFuente: string) {
    //pide hc de un paciente por dni, correspondiente a un circulo de clientes
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("tipoLogin", "medico")
      .set("idUsuario", "-3333")
      .set("pass", "-3333EXT")
      .set("nrodocPaciente", nrodocPaciente)
      .set("omitirFuente", omitirFuente)
      .set("circulo", "tandil");
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    //API ENDPOINT V2
    //usamos API_URL_BASE en lugar de API_URL temporalmente, por problemas con la apiurl de cass
    const url = `${this.API_URL_BASE}/${this.API_ENDPOINTS.getHCMultipleFuentes}`; // este va sin + this.session.getTokenActual() porque es va con un token especial
    const options = {
      headers,
      params,
    };
    let result = this.http.get<JSONResponse>(url, options);
    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp),
      tap((resp) => resp),
      catchError(
        this.handleAndThrow(`getHCMultipleFuentes`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }

  abrirEnBrowser(urlExterna: string) {
    window.open(urlExterna, "_blank");
  }

  isEmpty(obj) {
    for (const prop in obj) {
      //if (Object.hasOwn(obj, prop)) {
      if (Object.prototype.hasOwnProperty.call(obj, prop)) {
        return false;
      }
    }

    return true;
  }

  getCoberturasRecetario(): Observable<any> {
    const token = this.session.getTokenActual();
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.getCoberturasRecetario}` +
      this.session.getTokenActual();
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = {
      headers,
    };
    let result = this.http.get<JSONResponse>(url, options);
    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      catchError(
        this.handleAndThrow(`obtener coberturas recetario `, {
          url: url,
        }),
      ),
    );
  }
  cargarYprocesarCoberturasRecetario() {
    this.getCoberturasRecetario().subscribe({
      next: (data) => {
        console.log(
          "CoberturasRecetario recibidas: ",
          data["coberturasRecetario"].length,
        );
        console.log("sinonimosRecetario recibidas: ", data["sinonimos"].length);
        this.session.setCoberturasRecetario(data); // Llama a una función para procesar los datos
      },
      error: (error) => {
        console.error("Error al cargar coberturas recetario:", error);
      },
      complete: () => {
        console.log("Carga de datos de coberturas recetario"); // Opcional: para lógica adicional al completarse
      },
    });
  }

  hasPermission(): Promise<boolean> {
    if (this.platform.is("cordova")) {
      return this.speech.hasPermission();
    } else {
      return Promise.resolve(true); // En Web el navegador se encarga
    }
  }

  // 2. SOLICITAR PERMISOS
  requestPermission(): Promise<any> {
    if (this.platform.is("cordova")) {
      return this.speech.requestPermission();
    } else {
      return Promise.resolve();
    }
  }

  // 3. ESCUCHAR (La Magia Híbrida)
  escuchar(): Observable<string> {
    return new Observable((observer) => {
      // --- OPCIÓN A: MÓVIL (APP) ---
      if (this.platform.is("cordova")) {
        this.speech
          .startListening({
            language: "es-AR", // Cambia a 'es-AR' o 'es-MX' si prefieres
            matches: 1,
            showPopup: false,
            showPartial: true, // 🔥 Mantenemos esto activado
          })
          .subscribe(
            (matches) => {
              if (matches && matches.length > 0) {
                // Emitimos el texto parcial que nos llega
                observer.next(matches[0]);
                // ❌ QUITAMOS observer.complete() para que siga escuchando
              }
            },
            (error) => observer.error(error),
          );
      }

      // --- OPCIÓN B: WEB (PC / CHROME) ---
      else {
        if (!("webkitSpeechRecognition" in window)) {
          observer.error("Navegador no compatible. Use Google Chrome.");
          return;
        }

        this.recognition = new (window as any).webkitSpeechRecognition();
        this.recognition.lang = "es-AR";
        this.recognition.continuous = true; // 🔥 CRÍTICO: Seguir escuchando después de una pausa
        this.recognition.interimResults = true; // 🔥 CRÍTICO: Activar resultados en tiempo real

        this.recognition.onresult = (event) => {
          let textoProvisorio = "";

          // El navegador devuelve todas las frases dichas hasta el momento.
          // Debemos juntarlas todas en el string final que enviaremos.
          for (let i = event.resultIndex; i < event.results.length; ++i) {
            textoProvisorio += event.results[i][0].transcript;
          }

          if (textoProvisorio.trim().length > 0) {
            observer.next(textoProvisorio);
          }
        };

        this.recognition.onerror = (err) => {
          console.error("Web Speech API Error:", err);
          // No enviamos observer.error(err) inmediatamente a menos que sea fatal,
          // porque a veces lanza errores menores como 'no-speech' si haces silencio.
        };

        this.recognition.onend = () => {
          // El motor web se detuvo por sí solo (silencio largo o comando de parada)
          observer.complete();
        };

        try {
          this.recognition.start();
        } catch (e) {
          observer.error(e);
        }
      }
    });
  }

  // En tu voice-service.ts / mediware-hub.service.ts

  detener() {
    console.log("🔌 Orden recibida: Apagando micrófono...");

    // 1. SI ES WEB (PC/Chrome)
    // Es CRÍTICO aquí. Si no lo llamas, el punto rojo de "Grabando"
    // en la pestaña de Chrome se queda encendido para siempre.
    if (!this.platform.is("cordova") && this.recognition) {
      try {
        this.recognition.stop(); // <--- Esta es la orden nativa del navegador
        console.log("✅ Micrófono Web detenido.");
      } catch (e) {
        // A veces da error si ya estaba parado, no importa.
        console.log("El micrófono ya estaba apagado.");
      }
    }

    // 2. SI ES MÓVIL (APP)
    // En Android/iOS, al hacer unsubscribe suele cortarse solo,
    // pero por seguridad podemos forzarlo si el plugin lo permite.
    if (this.platform.is("cordova")) {
      // El plugin de Ionic a veces tiene stopListening()
      this.speech.stopListening();
    }
  }
  
  llamarPaciente(datosTurno: Appointment, nombreMedico: string) {
    //agrega para el llamador de turnos
    /*
    apellido: string;           // apellido del paciente
    codconsult: string;         // el codigo del consultorio para el turno; puede ser ''; o un codigo especificado
    nomConsultorio: string      // el nombre del consultorio; segun la configuracion del cliente; puede ser '' o un nombre
    */
    let params = new HttpParams({ encoder: new WebHttpUrlEncodingCodec() })
      .set("nombreMedico", nombreMedico)
      .set("nombrePaciente", datosTurno.apellido)
      .set("consultorio", datosTurno.codconsult || datosTurno.nomConsultorio );
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    //API ENDPOINT V2
    const url = `${this.API_URL}/${this.API_ENDPOINTS.llamarPaciente}` + this.session.getTokenActual(); //API ENDPOINT V2
    const options = {
      headers,
      params,
    };
    let result = this.http.get<JSONResponse>(url, options);
    return result.pipe(
      timeout(this.timeout),
      map((resp) => resp),
      tap((resp) => resp),
      catchError(
        this.handleAndThrow(`llamarPaciente`, {
          enviado: params,
          url: url,
        }),
      ),
    );
  }
  
  getItemsSetup(): Observable<any> {
    const url =
      `${this.API_URL}/${this.API_ENDPOINTS.getItemsSetup}` +
      this.session.getTokenActual();
    const headers = new HttpHeaders().set("Content-Type", "text/plain");
    const options = { headers };

    return this.http.get<JSONResponse>(url, options).pipe(
      timeout(this.timeout),
      map((resp) => resp.data),
      tap((data) => data),
      catchError(this.handleAndThrow("getItemsSetup ", { url })),
    );
  }
}



// WEBPACK FOOTER //
// ./src/providers/mediware-hub/mediware-hub.ts